import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react'
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';

if (window.location.hostname !== 'localhost') {
  LogRocket.init('9fvsjc/trygkalk');
}
setupLogRocketReact(LogRocket);

const logError = console.error

console.error = function (message?: any, ...optionalParams: any[]) {
  logError(message, ...optionalParams)
  LogRocket.captureMessage(message, {
    tags: {
      'console.error': true,
    },
  })
}

// TODO: Find a better way to prevent scrolling on number inputs
document.addEventListener("wheel", function (event) {
  if ((document.activeElement as any)?.type === "number") {
    (document.activeElement as any)?.blur();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
